import React from 'react'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'

import SelfSchedulingModel from '../../../../models/SelfScheduling'

import './SelfSchedulingAdditionalComments.sass'

export type SelfSchedulingAdditionalCommentsProps = {
    additionalComments: Models.SelfSchedulingAdditionalComments
    updateAdditionalComments: (additionalComments: Models.SelfSchedulingAdditionalComments) => void
}

const moduleName = 'self-scheduling-additional-comments'

function SelfSchedulingAdditionalComments(props: SelfSchedulingAdditionalCommentsProps) {
    const { additionalComments = SelfSchedulingModel.defaultAdditionalComments } = props

    function updateAdditionalComments(e: RadioChangeEvent) {
        props.updateAdditionalComments(e.target.value as Models.SelfSchedulingAdditionalComments)
    }

    return (
        <div className={moduleName}>
            <h3 className={`${moduleName}__title`}>Additional Information</h3>
            <div className={`${moduleName}__radio-buttons-wrapper`}>
                <div className={`${moduleName}__option-wrapper`}>
                    <VyneRadio
                        dataTestId="additional-info-required"
                        checked={additionalComments === 'required'}
                        onChange={updateAdditionalComments}
                        name="radio-widget-style"
                        value="required"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Required
                    </VyneRadio>
                </div>
                <div className={`${moduleName}__option-wrapper`}>
                    <VyneRadio
                        dataTestId="additional-info-optional"
                        checked={additionalComments === 'optional'}
                        onChange={updateAdditionalComments}
                        name="radio-widget-style"
                        value="optional"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Optional
                    </VyneRadio>
                </div>
                <div className={`${moduleName}__option-wrapper`}>
                    <VyneRadio
                        dataTestId="additional-info-none"
                        checked={additionalComments === 'none'}
                        onChange={updateAdditionalComments}
                        name="radio-widget-style"
                        value="none"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        None
                    </VyneRadio>
                </div>
            </div>
        </div>
    )
}

export default SelfSchedulingAdditionalComments
